import { useEffect, useState } from 'react';

export const useBuildNodeTree = (nodes: any, edges: any, stepTypeMap: any) => {
  const [nodeTree, setNodeTree] = useState([]);
  const [diagramData, setDiagramData] = useState([]);

  useEffect(() => {
    const buildNodeTree = () => {
      const steps = nodes.map((node: any) => {
        const nodeId = node.id;

        // Exclude loopBack edges from parents calculation to avoid circular dependencies
        const parents = edges
          .filter((edge: any) => edge.target === nodeId && edge.type !== 'loopBack')
          .map((edge: any) => edge.source);

        const onFailedStep = edges
          .filter((edge: any) => edge.source === nodeId && edge.type === 'onFailedStep')
          .map((edge: any) => edge.target);

        // Separate onCompleteStep and onParallelFlow properly
        // onCompleteStep only contains edges from green success button
        const onCompleteStep = edges
          .filter((edge: any) => edge.source === nodeId && edge.type === 'onCompleteStep')
          .map((edge: any) => edge.target);

        // onParallelFlow contains edges from gray buttons (noTitleEdge1 and noTitleEdge2)
        const onParallelFlow = edges
          .filter((edge: any) => edge.source === nodeId && (edge.type === 'noTitleEdge1' || edge.type === 'noTitleEdge2'))
          .map((edge: any) => edge.target);

        let { name, description, settings, formType, minimumAnswers, componentType, feild, fields, locationTrackingStep } = node.data.component;
        let { actor } = node.data.step;

        const normalizedFields = feild ?? fields ?? [];

        return {  
          uid: nodeId,
          title: node.data.label,
          stepType: node.data?.step?.stepType,
          parents,
          onCompleteStep,
          onFailedStep,
          onParallelFlow, // Added onParallelFlow field as required by backend
          reviewers: null,
          escalation: node.data?.step?.escalation || {},
          dependency: [],
          onUpload: {},
          onComplete: node.data?.step?.onComplete ? node.data?.step?.onComplete : {},
           notification: node.data?.step?.notification || {},
          onFailure: {},
          actor: Array.isArray(actor) ? actor.map((a: any) => (typeof a === 'string' ? a : a?.uid)).filter(Boolean) : [],

          component: {
            name,
            description,
            ...(settings ? { settings } : { settings: {} }),
            formType,
            minimumAnswers,
            fields: normalizedFields,
            componentType,
            locationTrackingStep
          },
          // Added edge metadata to preserve edge types for frontend rendering
          node: {
            id: nodeId,
            position: node.position,
            measured: node.measured ? node.measured : null,
            type: node.type,
            edgeMetadata: {
              outgoingEdges: edges
                .filter((edge: any) => edge.source === nodeId)
                .map((edge: any) => ({
                  target: edge.target,
                  type: edge.type,
                  sourceHandle: edge.sourceHandle
                }))
            }
          }
        };
      });

      return steps;
    };

    let nodeTree = buildNodeTree();

    let diagramData = nodeTree.map((nt: any) => nt.node);
    let treeData = nodeTree.map((nt: any) => {
      delete nt.node;
      return nt;
    });

    setDiagramData(diagramData);
    setNodeTree(treeData);
  }, [nodes, edges, stepTypeMap]);

  return { steps: nodeTree, diagramData };
};
